import axios, { AxiosResponse } from 'axios';

import { IFilters } from '../models/filters/i-filters.interface';

export const getFilters = (): Promise<AxiosResponse<IFilters>> => {
  return axios.get<IFilters>(`/backend/nft/filters`);
};
